import { Button } from 'antd';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router';
import tw from 'twin.macro';

import { PATH } from '@/Route';
import Tescriptions from '@/components/Tescriptions';
import { usePartnerNotice } from '@/hooks/queries/partner';

const NoticeDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data, isError } = usePartnerNotice({ id: Number(id) });

  if (isError) {
    navigate(PATH.NOTICE.INDEX, { replace: true });
    return null;
  }

  if (!data) {
    return null;
  }

  return (
    <section css={tw`flex flex-col gap-y-[32px] w-full`}>
      <Tescriptions column={2} title="공지사항">
        <Tescriptions.Item label="제목" span={2}>
          {data.title}
        </Tescriptions.Item>
        <Tescriptions.Item label="게시일" span={2}>
          {dayjs(data.publishedAt).format('YYYY-MM-DD')}
        </Tescriptions.Item>
        {!data.isGlobal && data.branches.length > 0 && (
          <Tescriptions.Item label="대상 지점" span={2}>
            {data.branches.map((b) => b.branchName).join(', ')}
          </Tescriptions.Item>
        )}
      </Tescriptions>

      <div
        className="rich-content"
        css={tw`p-[24px] border border-solid border-[#f0f0f0] rounded-[8px]`}
        dangerouslySetInnerHTML={{
          __html: data.contents,
        }}
      />

      <div css={tw`flex justify-center items-center gap-x-[8px]`}>
        <Button
          onClick={() => {
            navigate(PATH.NOTICE.INDEX);
          }}
        >
          목록으로
        </Button>
      </div>
    </section>
  );
};

export default NoticeDetail;
